import QuizVisualization from './QuizVisualization.container';

export default QuizVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quizvisualization/index.js